import { render, staticRenderFns } from "./oeffnungszeiten.vue?vue&type=template&id=2eb02b08"
import script from "./oeffnungszeiten.vue?vue&type=script&lang=js"
export * from "./oeffnungszeiten.vue?vue&type=script&lang=js"
import style0 from "./oeffnungszeiten.vue?vue&type=style&index=0&id=2eb02b08&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte\\Onlytonapoli\\onlytonapoliapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2eb02b08')) {
      api.createRecord('2eb02b08', component.options)
    } else {
      api.reload('2eb02b08', component.options)
    }
    module.hot.accept("./oeffnungszeiten.vue?vue&type=template&id=2eb02b08", function () {
      api.rerender('2eb02b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/oeffnungszeiten.vue"
export default component.exports